import * as React from 'react';
import { IconLogs } from '../../icons';
import { BackofficeRoute } from '../../types/route.interfaces';
import LogsPage from './pages/Logs';

const logsRoutes: BackofficeRoute[] = [
  {
    sidebar: {
      icon: IconLogs,
      translationKey: 'menu.adminLog',
    },
    path: '/events',
    element: <LogsPage />,
  },
];

export default logsRoutes;
